import Pusher from 'pusher-js';
import config from '../../config';

export const pusher = new Pusher(config.pusher_key, {
    cluster: 'eu',
    forceTLS: true,
});

export default pusher;
